import { defineMessages } from 'react-intl';

const messages = defineMessages({
  portknoxPlans: {
    id: 'Portknox Plans',
    defaultMessage: 'Portknox Plans',
  },
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  mode: {
    id: 'Mode',
    defaultMessage: 'Mode',
  },
  modeDescription: {
    id: 'Mode for PortknoxPlans component',
    defaultMessage: 'Select the mode: "website" or "app"',
  },
  paypalClientId: {
    id: 'PayPal Client ID',
    defaultMessage: 'PayPal Client ID',
  },
  paypalClientIdDescription: {
    id: 'PayPal Client ID description',
    defaultMessage:
      'PayPal Client ID for payment processing (optional, falls back to env variable)',
  },
});

export default messages;
